import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import TopBar from '../Layout/TopBar';
import Client from '../Client/Client';
import Promotion from '../Promotion/Promotion';
import Review from '../Review/Review';
import Live from '../Live/Live';
import Home from '../Home/Home';

const WrappedRoutes = ({
 isAdmin, clientId, isVisitor, promotionId,
}) => (
  <div>
    <TopBar />
    <div className="container__wrap">
      {/* eslint-disable-next-line no-nested-ternary */}
      {isAdmin ? (
        <switch>
          <Route exact path="/">
            <Redirect to="/admin" />
          </Route>
          <Route exact path="/admin" component={Home} />
        </switch>
      ) : isVisitor ? (
        <switch>
          <Route exact path="/">
            <Redirect to={`/client/${clientId}/${promotionId}`} />
          </Route>
          <Route exact path="/admin">
            <Redirect to={`/client/${clientId}/${promotionId}`} />
          </Route>
          <Route exact path="/client/:clientId">
            <Redirect to={`/client/${clientId}/${promotionId}`} />
          </Route>
        </switch>
      ) : (
        <switch>
          <Route exact path="/">
            <Redirect to={`/client/${clientId}`} />
          </Route>
          <Route exact path="/admin">
            <Redirect to={`/client/${clientId}`} />
          </Route>
        </switch>
      )}
      <Route exact path="/client/:clientId" component={Client} />
      <Route exact path="/client/:clientId/:promotionId" component={Promotion} />
      <Route exact path="/client/:clientId/:promotionId/live" component={Live} />
      <Route exact path="/client/:clientId/:promotionId/:reviewId/:categoryId" component={Review} />
    </div>
  </div>
);

WrappedRoutes.propTypes = {
  isAdmin: PropTypes.bool.isRequired,
  isVisitor: PropTypes.bool.isRequired,
  clientId: PropTypes.string.isRequired,
  promotionId: PropTypes.string.isRequired,
};

export default WrappedRoutes;
